<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>出库维护</el-breadcrumb-item>
            <el-breadcrumb-item>出库管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card style="height: 100%;">
            <el-card style="margin-top: 30px;background-color: #eee;">
                <span style="background-color: #ddd;width: 100%;padding-bottom: 10px;"> 出库单编号：{{ chukudan_bianhao }} </span>
                <el-table ref="multipleTable" :data="kucunAddData" tooltip-effect="dark" style="width: 100%"
                    @selection-change="handleSelectionChange" :default-sort="{ prop: 'xuhao', order: 'descending' }">
                    <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index }}</template>
                    </el-table-column>
                    <el-table-column prop="pro_uid" label="商品序号"  > </el-table-column>
                    <el-table-column prop="pro_name" label="商品名称"  > </el-table-column>
                    <el-table-column label="商品类别"  >
                        <template slot-scope="scope">{{ scope.row.leixing01 }}:{{ scope.row.leixing02 }}:{{
                            scope.row.leixing03 }}:{{ scope.row.leixing04 }}</template>
                    </el-table-column>
                    <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip>
                    </el-table-column>
                </el-table>
            </el-card>
             
        </el-card>
    </div>
</template>
<script>
import productTypeSelect from '../../tongyong/productType_select.vue'
import { checkMobileTest, checkSfzId } from '../config/validator';
export default {
    props: [
        'chukudanUid',
        'chukudanBianhao'
    ],
    data() {
        return {
            chukudan_bianhao: '',
            kucunAddData: [],
            kucunAddData_proUid: [],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_chuku_mingxi',
                chukudan_uid: this.chukudanUid
            },
            
            total: 0
            // 表单规则项
        };
    },
    created() {
        this.getchukuMingxiList()
        // this.rukudan_bianhao_get()
        this.chukudan_bianhao = this.chukudanBianhao
        console.log(this.rukudanBianhao)
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        async getchukuMingxiList() {
            console.log(999, this.queryInfo)
            const { data: res } = await this.$http.post('api', this.queryInfo);
            console.log(JSON.parse(res.data)[0].dataList)
            this.kucunAddData = JSON.parse(res.data)[0].dataList
            // console.log(this.total)
        }
        //  分页第一项下拉触发
    }
}
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
}
</style>
